import { PaysafeEventType } from './paysafe-event-type.enum';
import { PaysafeFormField } from './paysafe-form-field.enum';

export interface PaysafeEvent {
  type: PaysafeEventType;
  target: {
    fieldName: PaysafeFormField;
  };
  data?: {
    isEmpty: boolean;
  };
}
